export const setCursor = (div: HTMLElement, position: number, length = 1) => {
  div.focus();

  const range = document.createRange();
  const selection = window.getSelection();

  // Flatten the text content of the editable div
  let charIndex = 0;
  let nodeStack: Node[] = [div];
  let node: Node | undefined;

  while ((node = nodeStack.pop())) {
    if (node.nodeType === Node.TEXT_NODE) {
      const textLength = node.textContent?.length ?? 0;
      if (charIndex + textLength >= position) {
        // Found the node that contains the position
        range.setStart(node, position - charIndex);
        range.setEnd(node, position - charIndex + length);

        selection?.removeAllRanges();
        selection?.addRange(range);
        return;
      }
      charIndex += textLength;
    } else {
      // Push children in reverse order (so they pop in normal order)
      const children = Array.from(node.childNodes);
      for (let i = children.length - 1; i >= 0; i--) {
        nodeStack.push(children[i]);
      }
    }
  }

  // If position is beyond text length, set cursor at end
  range.selectNodeContents(div);
  range.collapse(false);
  selection?.removeAllRanges();
  selection?.addRange(range);
};
